<script>import MdKeyboardArrowLeft from "../../icons/MdKeyboardArrowLeft.svelte";
import Input from "../Input/Input.svelte";
import MdKeyboardArrowRight from "../../icons/MdKeyboardArrowRight.svelte";
import FaArrowUp from "../../icons/FaArrowUp.svelte";
import ChevronDown from "../../icons/ChevronDown.svelte";
import { createEventDispatcher } from "svelte";
import { writable, get } from "svelte/store";
import { cn } from "../../utils/twClnm.js";
export let currentPage = writable(1);
export let pageLimit = writable(10);
export let totalItems = 100;
export let totalPages = 0;
export let limitOptions = [5, 10, 20, 50];
let goTo = 1;
const dispatch = createEventDispatcher();
let selectedValue = `${get(pageLimit)}`;
$: {
  totalPages = Math.ceil(totalItems / get(pageLimit));
}
function nextPage() {
  currentPage.update((n) => n < totalPages ? n + 1 : n);
  changePageProps();
}
function prevPage() {
  currentPage.update((n) => n > 1 ? n - 1 : n);
  changePageProps();
}
function goToPage(page) {
  $currentPage = page;
  changePageProps();
}
function changePageProps(page) {
  dispatch("toggle", {
    currentPage: page || $currentPage,
    pageLimit: selectedValue
  });
}
function fixPage(value) {
  const numValue = value ? Number(value) : 0;
  return numValue >= 1 && numValue <= totalPages ? numValue : 1;
}
function handleChange(e) {
  const value = e.target.value;
  goTo = fixPage(value);
  $currentPage = goTo;
  changePageProps(goTo);
}
function handleInput(e) {
  const value = e.target.value;
  if (value === "") return;
  goTo = fixPage(value);
}
function scrollToTop() {
  const main = document.querySelector('[data-scroll-id="listings-grid"]');
  if (main) {
    main.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
}
function onPageLimitChange() {
  $currentPage = 1;
  changePageProps();
}
</script>

<div class="tw-flex tw-items-center tw-justify-between">
	<div class="tw-flex tw-items-center">
		<button
			on:click={prevPage}
			disabled={$currentPage === 1}
			class="tw-p-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-secondary"
		>
			<MdKeyboardArrowLeft />
		</button>
		{#if totalPages <= 7}
			{#each Array.from({ length: totalPages }, (_, i) => i + 1) as page}
				<button
					on:click={() => goToPage(page)}
					class:selected={$currentPage === page}
					class={cn({
							'tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6': true,
							'tw-bg-primary tw-text-white': $currentPage === page,
							'tw-bg-none tw-text-dark': !($currentPage === page),
						})}
					>{page}</button
				>
			{/each}
		{:else if $currentPage <= 4}
			{#each Array.from({ length: 5 }, (_, i) => i + 1) as page}
				<button
					on:click={() => goToPage(page)}
					class:selected={$currentPage === page}
					class={cn({
							'tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6': true,
							'tw-bg-primary tw-text-white': $currentPage === page,
							'tw-bg-none tw-text-dark': !($currentPage === page),
						})}
					>{page}</button
				>
			{/each}
			<span
				class={`tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6`}
				>...</span
			>
			<button
				on:click={() => goToPage(totalPages - 1)}
				class={`tw-rounded-md tw-bg-none tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-dark`}
				>{totalPages - 1}</button
			>
			<button
				on:click={() => goToPage(totalPages)}
				class={`tw-rounded-md tw-bg-none tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-dark`}
				>{totalPages}</button
			>
		{:else if $currentPage >= totalPages - 3}
			{#each [1,2] as pageNumber}
				<button
					on:click={() => goToPage(pageNumber)}
					class={`tw-rounded-md tw-bg-none tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-dark`}
					>{pageNumber}</button
				>
			{/each}
			<span
				class={`tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6`}
				>...</span
			>
			{#each Array.from({ length: 5 }, (_, i) => totalPages - 4 + i) as page}
				<button
					on:click={() => goToPage(page)}
					class:selected={$currentPage === page}
					class={cn({
							'tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6': true,
							'tw-bg-primary tw-text-white': $currentPage === page,
							'tw-bg-none tw-text-dark': !($currentPage === page),
						})}
					>{page}</button
				>
			{/each}
		{:else}
			{#each [1,2] as pageNumber}
				<button
					on:click={() => goToPage(pageNumber)}
					class={`tw-rounded-md tw-bg-none tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-dark`}
					>{pageNumber}</button
				>
			{/each}
			<span
				class={`tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6`}
				>...</span
			>
			{#each Array.from({ length: 5 }, (_, i) => $currentPage - 2 + i) as page}
				<button
					on:click={() => goToPage(page)}
					class:selected={$currentPage === page}
					class={cn({
							'tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6': true,
							'tw-bg-primary tw-text-white': $currentPage === page,
							'tw-bg-none tw-text-dark': !($currentPage === page),
						})}
					>{page}</button
				>
			{/each}
			<span
				class={`tw-rounded-md tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6`}
				>...</span
			>
			<button
				on:click={() => goToPage(totalPages - 1)}
				class={`tw-rounded-md tw-bg-none tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-dark`}
				>{totalPages - 1}</button
			>
			<button
				on:click={() => goToPage(totalPages)}
				class={`tw-rounded-md tw-bg-none tw-px-4 tw-py-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-dark`}
				>{totalPages}</button
			>
		{/if}
		<button
			on:click={nextPage}
			disabled={$currentPage == totalPages}
			class="tw-p-2 tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-secondary"
		>
			<MdKeyboardArrowRight />
		</button>
	</div>
	<div class="tw-relative">
		<button
			class="tw-flex tw-items-center tw-gap-3 tw-rounded-full tw-bg-primary tw-px-8 tw-py-3 tw-text-sm tw-font-medium tw-text-white"
			on:click={scrollToTop}
		>
			<FaArrowUp />
			Back to Top
		</button>
	</div>
	<div class="tw-relative tw-flex tw-items-center tw-gap-5">
		<div
			class="tw-relative tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-solid tw-border-inputborder tw-px-5 tw-py-2"
		>
			<select
				bind:value={selectedValue}
				on:change={onPageLimitChange}
				class="tw-appearance-none tw-bg-transparent tw-pr-6 focus:tw-outline-0"
			>
				{#each limitOptions as page}
					<option class="tw-font-inter tw-font-medium tw-text-dark" value={`${page}`}>
						<b>{page}</b> / page
					</option>
				{/each}
			</select>

			<div class="tw-absolute tw-right-4 tw-z-10">
				<ChevronDown />
			</div>
		</div>
		<div class="tw-flex tw-items-center tw-gap-2">
			<span>Go to</span>
			<Input
				class="tw-w-24 tw-rounded tw-border tw-border-solid tw-border-inputborder tw-px-4 tw-py-2 focus:tw-outline-0"
				type="number"
				bind:value={goTo}
				min="1"
				max={totalPages}
				on:change={handleChange}
				on:input={handleInput}
			/>
		</div>
	</div>
</div>
